var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgForwardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "5669AB35-C6C6-40CD-839F-4D6FFA4C1EDA") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Eazle---New-menu-and-order-pages-design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "new/continue-order-open",
    transform: "translate(-257, -512)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(24, 507)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "next",
    transform: "translate(219, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "forward-icon",
    transform: "translate(14, 5)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.6,23.0666667 C8.35556,22.8222667 8.23333333,22.5110667 8.23333333,22.1333333 C8.23333333,21.7556 8.35556,21.4444 8.6,21.2 L13.8,16 L8.6,10.7999867 C8.35556,10.5555333 8.23333333,10.2444267 8.23333333,9.86665333 C8.23333333,9.48886667 8.35556,9.17776 8.6,8.93332 C8.84444,8.68886667 9.15556,8.56665333 9.53333333,8.56665333 C9.91110667,8.56665333 10.2222267,8.68886667 10.4666667,8.93332 L16.6,15.0666667 C16.7333333,15.2 16.8277333,15.3444 16.8833333,15.5 C16.9389333,15.6556 16.9666667,15.8222667 16.9666667,16 C16.9666667,16.1777333 16.9389333,16.3444 16.8833333,16.5 C16.8277333,16.6556 16.7333333,16.8 16.6,16.9333333 L10.4666667,23.0666667 C10.2222267,23.3110667 9.91110667,23.4333333 9.53333333,23.4333333 C9.15556,23.4333333 8.84444,23.3110667 8.6,23.0666667 Z",
    id: "Path",
    fill: "#00414B",
    fillRule: "nonzero",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6,23.0666667 C15.35556,22.8222667 15.2333333,22.5110667 15.2333333,22.1333333 C15.2333333,21.7556 15.35556,21.4444 15.6,21.2 L20.8,16 L15.6,10.7999867 C15.35556,10.5555333 15.2333333,10.2444267 15.2333333,9.86665333 C15.2333333,9.48886667 15.35556,9.17776 15.6,8.93332 C15.84444,8.68886667 16.15556,8.56665333 16.5333333,8.56665333 C16.9111067,8.56665333 17.2222267,8.68886667 17.4666667,8.93332 L23.6,15.0666667 C23.7333333,15.2 23.8277333,15.3444 23.8833333,15.5 C23.9389333,15.6556 23.9666667,15.8222667 23.9666667,16 C23.9666667,16.1777333 23.9389333,16.3444 23.8833333,16.5 C23.8277333,16.6556 23.7333333,16.8 23.6,16.9333333 L17.4666667,23.0666667 C17.2222267,23.3110667 16.9111067,23.4333333 16.5333333,23.4333333 C16.15556,23.4333333 15.84444,23.3110667 15.6,23.0666667 Z",
    id: "Path-Copy",
    fill: "#00414B",
    fillRule: "nonzero",
    mask: "url(#mask-2)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForwardIcon);
export default __webpack_public_path__ + "static/media/forward-icon.9dd1862ad39bc0630c039dbab50b6f84.svg";
export { ForwardRef as ReactComponent };